<div class="categories-picker" [class.visible]="showCategories">
  <app-search-wrap
    title="{{ 'edit_product.form.s_category' | translate }}"
    (onSearch)="search($event)"
    (close)="search('')"
    (back)="onBack()"
  ></app-search-wrap>
  @if (!isSearch) {
    <div>
      @for (category of productService.sortedCategories; track category) {
        <div class="categories-picker__item">
          <div
            class="categories-picker__item--parent"
            [ngClass]="category._id === selectedCategoryId ? 'selected' : ''"
            >
            <div class="category-info">
              <div>{{ category.name }}</div>
              <span>{{ category.innerCategories.length }} inner categories</span>
            </div>
            <div
              class="select-category"
              (click)="selectCategory(category._id)"
              >
              {{ 'edit_product.form.select' | translate }}
            </div>
          </div>
          @if (category.innerCategories.length > 0) {
            <div>
              @for (innerCategory of category.innerCategories; track innerCategory) {
                <div
                  class="categories-picker__item--child"
                  [ngClass]="innerCategory._id === selectedCategoryId ? 'selected' : ''"
                  >
                  <div>{{ innerCategory.name }}</div>
                  <div>
                    <div
                      class="select-category"
                      (click)="selectCategory(innerCategory._id)"
                      >
                      {{ 'edit_product.form.select' | translate }}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
  @if (isSearch) {
    <div>
      @for (category of filteredCategoryList; track category) {
        <div class="categories-picker__item">
          <div class="categories-picker__item--parent search">
            <div class="category-info">
              <div>{{ category.name }}</div>
            </div>
            @if (category._id !== selectedCategoryId) {
              <div
                class="select-category"
                (click)="selectCategory(category._id)"
                >
                Select
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  <div class="new-category">
    <ion-item class="default-input">
      <ion-label position="stacked">{{ 'edit_product.form.add_category' | translate }}</ion-label>
      <ion-input
        type="text"
        [(ngModel)]="newCategoryName"
        placeholder="{{ 'edit_product.form.n_category_n' | translate }}"
      ></ion-input>
      <button block class="action-btn" ion-button (click)="addCategory()"  [disabled]="newCategoryName === ''">{{ 'home.create' | translate }}</button>
    </ion-item>
  </div>
</div>
